<div class="container-fluid regular-tab-content">
  <div class="green-table">
    <div
      class="table-action-wrapper d-flex align-items-center justify-content-between"
    >
      <div id="reports_dqr_bulidings_search" class="search-input">
        <img
          src="../../assets/icons/search.svg"
          alt="Search icon"
          (click)="search()"
        />
        <input
          class="smaller-font"
          type="text"
          [placeholder]="'COMMON.SEARCH' | translate"
          [(ngModel)]="searchText"
          (keydown.enter)="search()"
          (ngModelChange)="this.searchTextUpdate.next($event)"
        />
      </div>
      <div class="actions-box ml-auto d-flex">
        <div>
          <div class="date-filters d-flex">
            <div id="reports_dqr_bulidings_date-type" class="datetype-picker">
              <div
                class="dropdown date-type-dropdown smaller-font"
                (click)="showSelectDateType = !showSelectDateType"
                click-stop-propagation
              >
                <span class="smaller-font"
                  >{{ "COMMON.DATE_TYPE.TITLE" | translate }}:</span
                >
                <span class="smaller-font" style="width: 50%">{{ selectedDateTypeDisplay | translate }}</span>
                <i class="arrow-custom --small down"></i>
              </div>
              <div class="dropdown-opened" *ngIf="showSelectDateType">
                <div
                  [id]="'reports_dqr_bulidings_date-type-' + (i + 1)"
                  (click)="
                    selectDateType(dateType);
                    datesValid() == true && (dateTo || dateFrom) && search()
                  "
                  *ngFor="let dateType of dateTypes; let i = index"
                >
                  <div>{{ dateType.translation | translate }}</div>
                </div>
              </div>
            </div>
            <div id="reports_dqr_bulidings_date-from" class="datepicker-box space-right smaller-font">
              <label class="smaller-font" for="dateFrom">
                {{ "COMMON.FROM" | translate }}:
              </label>
              <input
                onclick="this.showPicker()"
                type="date"
                id="dateFrom"
                name="dateFrom"
                [ngClass]="
                  !datesValid() ? 'datepicker-input-error' : 'datepicker-input'
                "
                [(ngModel)]="dateFrom"
                (change)="datesValid() == true && search()"
              />
              <i class="arrow-custom --small down"></i>
            </div>

            <div id="reports_dqr_bulidings_date-to" class="datepicker-box space-right smaller-font">
              <label for="dateTo" class="right-label smaller-font">
                {{ "COMMON.TO" | translate }}:
              </label>
              <input
                onclick="this.showPicker()"
                type="date"
                id="dateTo"
                name="dateTo"
                [ngClass]="
                  !datesValid() ? 'datepicker-input-error' : 'datepicker-input'
                "
                [(ngModel)]="dateTo"
                (change)="datesValid() == true && search()"
              />
              <i class="arrow-custom --small down"></i>
            </div>
          </div>
        </div>

        <div
          id="reports_dqr_bulidings_sort-by"
          class="sort-by-root"
          (click)="showSortBy = !showSortBy"
          click-stop-propagation
        >
          <div class="dropdown">
            <span class="smaller-font"
              >{{ "COMMON.SORT_BY.TITLE" | translate }}:</span
            >
            <span class="smaller-font" style="width: 40%;">{{ sortByName | translate }}</span>
            <i class="arrow-custom --small down"></i>
          </div>
          <div class="dropdown-opened" *ngIf="showSortBy">
            <div id="reports_dqr_bulidings_sort-by-newest" (click)="sortBy(sortByOptions.NEWEST)">
              {{ "COMMON.SORT_BY.NEWEST" | translate }}
            </div>
            <div id="reports_dqr_bulidings_sort-by-slrn-asc" (click)="sortBy(sortByOptions.SLRN_ASC)">
              {{ "COMMON.SORT_BY.SLRN_ASC" | translate }}
            </div>
            <div id="reports_dqr_bulidings_sort-by-slrn-desc" (click)="sortBy(sortByOptions.SLRN_DESC)">
              {{ "COMMON.SORT_BY.SLRN_DESC" | translate }}
            </div>
          </div>
        </div>

        <button class="button primary--white four-radius" (click)="download()">
          <span class="smaller-font">{{ "COMMON.DOWNLOAD" | translate }}</span>
        </button>
      </div>
    </div>
    <div class="filter">
      <div class="filter-list smaller-font">
        <span class="label">{{ "COMMON.FILTER" | translate }}</span>
        <app-multi-select-dropdown
          *ngIf="!authService.hasCimDataIntegration"
          id="reports_dqr_bulidings_region_filter"
          [borderRadius]="'0.4rem'"
          class="multiselect"
          [clicked]="clicked"
          [items]="regions"
          [label]="'COMMON.BU.PLURAL'"
          [showMore]="false"
          [requireApply]="true"
          (shareIndividualCheckedList)="selectRegion($event)"
        >
        </app-multi-select-dropdown>
        <app-multi-select-dropdown
          *ngIf="!authService.hasCimDataIntegration"
          id="reports_dqr_bulidings_area_filter"
          class="multiselect"
          [clicked]="clicked"
          [borderRadius]="'0.4rem'"
          [items]="areas"
          [label]="'COMMON.UT.PLURAL'"
          [showMore]="false"
          [requireApply]="true"
          (shareIndividualCheckedList)="selectArea($event)"
        >
        </app-multi-select-dropdown>
        <app-multi-select-dropdown
          *ngIf="authService.hasCimDataIntegration"
          id="reports_dqr_bulidings_geo_region_filter"
          [borderRadius]="'0.4rem'"
          class="multiselect"
          [clicked]="clicked"
          [items]="geoRegions"
          [label]="'COMMON.BU.PLURAL'"
          [showMore]="false"
          [requireApply]="true"
          (shareIndividualCheckedList)="selectGeoRegion($event)"
        >
        </app-multi-select-dropdown>
        <app-multi-select-dropdown
          *ngIf="authService.hasCimDataIntegration"
          id="reports_dqr_bulidings_sub_geo_region_filter"
          class="multiselect"
          [clicked]="clicked"
          [borderRadius]="'0.4rem'"
          [items]="subGeoRegions"
          [label]="'COMMON.UT.PLURAL'"
          [showMore]="false"
          [requireApply]="true"
          (shareIndividualCheckedList)="selectSubGeoRegion($event)"
        >
        </app-multi-select-dropdown>

        <select
          id="reports_dqr_bulidings_user-type_filter"
          name="st-select"
          (change)="selectUserType($event)"
          class="form-select"
        >
          <option value="" [selected]="!userType" disabled>
            {{ "COMMON.USER.TYPE.TITLE" | translate }}
          </option>
          <option
            [id]="'reports_dqr_bulidings_user-type_filter-' + (i + 1)"
            [selected]="userType == o.value"
            *ngFor="let o of userTypeOptions; let i = index"
            value="{{ o.value }}"
          >
            {{ o.translation | translate }}
          </option>
        </select>

        <app-multi-select-dropdown
          id="reports_dqr_bulidings_user_filter"
          class="multiselect"
          [searchFilterActive]="true"
          [borderRadius]="'0.4rem'"
          (filterValue)="applySearchFilter($event)"
          [clicked]="clicked"
          [items]="filteredUsers"
          [label]="'COMMON.USER.PLURAL'"
          [showMore]="false"
          [requireApply]="true"
          (shareIndividualCheckedList)="selectUsers($event)"
        >
        </app-multi-select-dropdown>
        <select
          id="reports_dqr_bulidings_tag_filter"
          name="tag-select"
          (change)="selectTag($event)"
          class="form-select"
        >
          <option value="" [selected]="!tag" disabled>
            {{ "COMMON.TAG.TITLE" | translate }}
          </option>
          <option
            [id]="'reports_dqr_bulidings_tag_filter-' + (i + 1)"
            [selected]="tag == t.value"
            *ngFor="let t of tagOptions; let i = index"
            value="{{ t.value }}"
          >
            {{ t.translation | translate }}
          </option>
        </select>
      </div>
      <div *ngIf="selectedFilters.length > 0">
        <app-filter-checklist
              [filters]="selectedFilters"
              (resetFilterEmitter)="resetFilter($event)"
              (removeFilterEmitter)="removeFilter($event)"
              [useApply]="true"
              (applyFilterEmitter)="applyFilter($event)"
        >
        </app-filter-checklist>
      </div>
      <div *ngIf="buildings">
        <table class="table border-bottom">
          <thead class="table-light">
            <tr>
              <th id="reports_dqr_bulidings_table_header_checkbox" class="checkbox">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [ngModel]="allCheckboxesChecked"
                  (click)="checkAllCheckboxes()"
                />
              </th>
              <th id="reports_dqr_bulidings_table_header_slrn">{{ "COMMON.SLRN" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_address">{{ "COMMON.ADDRESS" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_connected-accounts">{{ "BUILDINGS.CONNECTED_ACCS" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_region">{{ "COMMON.BU.SINGLE" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_district">{{ "COMMON.UT.SINGLE" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_feeder">{{ "COMMON.MBC_DETAILS.FEEDER_NAME" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_dt">{{ "COMMON.DT_NAME" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_validation-status">{{ "COMMON.VALIDATION_STATUS" | translate }}</th>
              <th id="reports_dqr_bulidings_table_header_tag">{{ "COMMON.TAG.TITLE" | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              [id]="'reports_dqr_bulidings_table_row-' + (i + 1)" *ngFor="let building of buildings; let i = index"
              (click)="selectDataQuality(building.id)"
            >
              <td [id]="'reports_dqr_bulidings_table_checkbox-' + (i + 1)">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [ngModel]="building.isChecked"
                  (click)="checkBuilding(building.id)"
                />
              </td>
              <td [id]="'reports_dqr_bulidings_table_slrn-' + (i + 1)" (click)="setFilterStorage()">
                {{ building?.slrn | hasValue }}
              </td>
              <td [id]="'reports_dqr_bulidings_table_address-' + (i + 1)" (click)="setFilterStorage()">
                {{ building.address | hasValue }}
              </td>
              <td [id]="'reports_dqr_bulidings_table_connected-accounts-' + (i + 1)" (click)="setFilterStorage()">
                {{ building.customerCount | number | hasValue }}
              </td>
              <td [id]="'reports_dqr_bulidings_table_region-' + (i + 1)" (click)="setFilterStorage()">
                {{ (authService.hasCimDataIntegration ? building.geographicalRegionName : building.region) | hasValue }}
              </td>
              <td [id]="'reports_dqr_bulidings_table_district-' + (i + 1)" (click)="setFilterStorage()">
                {{ (authService.hasCimDataIntegration ? building.subGeographicalRegionName : building.area) | hasValue }}
              </td>
              <td [id]="'reports_dqr_bulidings_table_feeder-' + (i + 1)" (click)="setFilterStorage()">
                {{ (authService.hasCimDataIntegration ? building.acLineName : building.feederName) | hasValue }}
              </td>
              <td [id]="'reports_dqr_bulidings_table_dt-' + (i + 1)" (click)="setFilterStorage()">
                {{ (authService.hasCimDataIntegration ? building.substationName : building.dtName) | hasValue }}
              </td>
              <td [id]="'reports_dqr_bulidings_table_validation-status-' + (i + 1)" (click)="setFilterStorage()">
                <div
                  *ngIf="building.status"
                  class="building-status"
                  [ngClass]="{
                    'complete-building': building.status == 'Complete',
                    'pending-building': building.status == 'Pending',
                    'assigned-building':
                      building.status == 'Assigned' ||
                      building.status == 'Retagged',
                    'dark-red-status v-2': building.status == 'Rejected'
                  }"
                >
                  {{ building.status }}
                </div>
                <div *ngIf="!building.status" class="building-status">
                  --------
                </div>
              </td>
              <td [id]="'reports_dqr_bulidings_table_tag-' + (i + 1)">
                <div
                  *ngIf="!building.issueType"
                  class="green-status v-2"
                  (click)="setFilterStorage()"
                >
                  {{ "COMMON.BUILDING.TYPE.TAGGED" | translate }}
                </div>
                <div
                  *ngIf="building.issueType"
                  class="red-status v-2"
                  (click)="setFilterStorage()"
                >
                  {{ "COMMON.BUILDING.TYPE.INACCESSIBLE" | translate }}
                </div>
              </td>
              <td class="more-icon" (click)="setFilterStorage()">
                <img
                  src="../../assets/icons/more-icon.svg"
                  alt="More icon"
                  class="more-icon"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <app-paging
            *ngIf="count > 0"
            [pageSize]="pageSize"
            [count]="count"
            [currentPage]="currentPage"
            [useDirect]="true"
            (pageChange)="pageChange($event)"
          ></app-paging>
        </div>
      </div>
    </div>
  </div>
</div>
